__turbopack_context__.v({
  "action": "checkout-module__29JHIq__action",
  "badge": "checkout-module__29JHIq__badge",
  "body": "checkout-module__29JHIq__body",
  "button": "checkout-module__29JHIq__button",
  "checkout": "checkout-module__29JHIq__checkout",
  "choiceGrid": "checkout-module__29JHIq__choiceGrid",
  "close": "checkout-module__29JHIq__close",
  "discount": "checkout-module__29JHIq__discount",
  "grandTotal": "checkout-module__29JHIq__grandTotal",
  "header": "checkout-module__29JHIq__header",
  "headerEnd": "checkout-module__29JHIq__headerEnd",
  "headerInner": "checkout-module__29JHIq__headerInner",
  "layout": "checkout-module__29JHIq__layout",
  "left": "checkout-module__29JHIq__left",
  "legal": "checkout-module__29JHIq__legal",
  "method": "checkout-module__29JHIq__method",
  "methodActive": "checkout-module__29JHIq__methodActive",
  "methodForm": "checkout-module__29JHIq__methodForm",
  "notice": "checkout-module__29JHIq__notice",
  "option": "checkout-module__29JHIq__option",
  "optionBody": "checkout-module__29JHIq__optionBody",
  "optionDetail": "checkout-module__29JHIq__optionDetail",
  "optionName": "checkout-module__29JHIq__optionName",
  "optionSelected": "checkout-module__29JHIq__optionSelected",
  "platform": "checkout-module__29JHIq__platform",
  "price": "checkout-module__29JHIq__price",
  "productBody": "checkout-module__29JHIq__productBody",
  "productDetail": "checkout-module__29JHIq__productDetail",
  "productFallback": "checkout-module__29JHIq__productFallback",
  "productImage": "checkout-module__29JHIq__productImage",
  "productName": "checkout-module__29JHIq__productName",
  "productPrice": "checkout-module__29JHIq__productPrice",
  "section": "checkout-module__29JHIq__section",
  "secure": "checkout-module__29JHIq__secure",
  "seller": "checkout-module__29JHIq__seller",
  "sellerCaption": "checkout-module__29JHIq__sellerCaption",
  "sellerInitial": "checkout-module__29JHIq__sellerInitial",
  "sellerLogo": "checkout-module__29JHIq__sellerLogo",
  "sellerName": "checkout-module__29JHIq__sellerName",
  "stepNav": "checkout-module__29JHIq__stepNav",
  "stepNumber": "checkout-module__29JHIq__stepNumber",
  "stepTitle": "checkout-module__29JHIq__stepTitle",
  "subtitle": "checkout-module__29JHIq__subtitle",
  "summary": "checkout-module__29JHIq__summary",
  "summaryItem": "checkout-module__29JHIq__summaryItem",
  "summaryItems": "checkout-module__29JHIq__summaryItems",
  "summarySeller": "checkout-module__29JHIq__summarySeller",
  "summaryTitle": "checkout-module__29JHIq__summaryTitle",
  "surface": "checkout-module__29JHIq__surface",
  "title": "checkout-module__29JHIq__title",
  "totalRow": "checkout-module__29JHIq__totalRow",
  "totals": "checkout-module__29JHIq__totals",
  "trust": "checkout-module__29JHIq__trust",
  "trustItem": "checkout-module__29JHIq__trustItem",
});
